/*!
 * devextreme-angular
 * Version: 26.1.6
 * Build date: Fri Oct 16 2026
 *
 * Copyright (c) 2012 - 2026 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/DevExtreme
 */

/* tslint:disable:max-line-length */

/* tslint:disable:use-input-property-decorator */

import {
    Component,
    NgModule,
    Host,
    SkipSelf
} from '@angular/core';





import {
    DxIntegrationModule,
    NestedOptionHost,
} from 'devextreme-angular/core';
import { DxiChartSeries } from './base/chart-series-dxi';

import { PROPERTY_TOKEN_series } from 'devextreme-angular/core/tokens';

@Component({
    selector: 'dxi-series',
    template: '',
    styles: [''],
    imports: [ DxIntegrationModule ],
    providers: [
        NestedOptionHost,
        {
           provide: PROPERTY_TOKEN_series,
           useExisting: DxiSeriesComponent,
        }
    ],
    inputs: [
        'aggregation',
        'argumentField',
        'axis',
        'barOverlapGroup',
        'barPadding',
        'barWidth',
        'border',
        'closeValueField',
        'color',
        'cornerRadius',
        'dashStyle',
        'highValueField',
        'hoverMode',
        'hoverStyle',
        'ignoreEmptyPoints',
        'innerColor',
        'label',
        'lowValueField',
        'maxLabelCount',
        'minBarSize',
        'name',
        'opacity',
        'openValueField',
        'pane',
        'point',
        'rangeValue1Field',
        'rangeValue2Field',
        'reduction',
        'selectionMode',
        'selectionStyle',
        'showInLegend',
        'sizeField',
        'stack',
        'tag',
        'tagField',
        'type',
        'valueErrorBar',
        'valueField',
        'visible',
        'width',
        'argumentType',
        'minSegmentSize',
        'smallValuesGrouping',
        'closed'
    ]
})
export class DxiSeriesComponent extends DxiChartSeries {

    protected get _optionPath() {
        return 'series';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }



    ngOnDestroy() {
        this._deleteRemovedOptions(this._fullOptionPath());
    }

}

@NgModule({
  imports: [
    DxiSeriesComponent
  ],
  exports: [
    DxiSeriesComponent
  ],
})
export class DxiSeriesModule { }
